import { AddRounded, ContentCopy, Delete, Edit, ExpandMore, InfoOutline, PersonAdd, Settings, Update, Upload } from "@mui/icons-material";
import {
    Box,
    Button,
    Checkbox,
    Chip,
    CircularProgress,
    Collapse,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    Link,
    MenuItem,
    Paper,
    Popover,
    Radio,
    Select,
    Snackbar,
    Stack,
    TextField,
    ToggleButton,
    ToggleButtonGroup,
    Tooltip,
    Typography
} from "@mui/material";
import { useClassroomStore } from "../../../store/classroom-store";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import renderAvatar from "../../../components/render-avatar";
import { Classroom, CreateNewClassroom } from "../../../models/classroom";
import CircleStat from "./sections/classroom-stat";
import CollboratorDialog from "./components/collaborator-dialog";
import { Collaborator, CreateNewCollaborator } from "../../../models/collaborator";
import ClassroomStats from "./sections/classroom-stat";
import CollaboratorSection from "./sections/collaborator-section";
import ClassroomDetails from "./sections/classroom-details";
import { useClassroomActions } from "../../../hooks/useClassroomActions";


function Overview() {
  const { classroom_id } = useParams<{ classroom_id: string }>();

  const { classrooms } = useClassroomActions();

  const classroom = classrooms?.[Number(classroom_id)];


  useEffect(() => {
  }, [classrooms]);

  if (!classroom) {
    return (<></>);
  }
  return (
    <Stack spacing={4} >

      <ClassroomStats
        students={classroom.enrollment_count}
        earnings={classroom.earnings}
        enrollment_url={`https://students.elms.ng/enroll/${classroom.enrollment_code}`}
      />

      {/* <CollaboratorSection classroom_id={classroom_id!} classroom={classroom}/> */}
    
    

      <ClassroomDetails cls={classroom}/>

      
    </Stack>
  );
}

export default memo(Overview);